import React from 'react';
import { useSelector } from 'react-redux';
import { Menu } from 'antd';
import { NavLink, useRouteMatch } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import propTypes from 'prop-types';

const { SubMenu } = Menu;

const MenuItems = ({ darkMode, toggleCollapsed, topMenu }) => {
  const { path } = useRouteMatch();
  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath.split('/');

  const userId = useSelector((state) => state.auth.userId);

  return (
    <Menu
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      theme={darkMode && 'dark'}
      // // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [
              `${
                mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
              }`,
            ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
      overflowedIndicator={<FeatherIcon icon="more-vertical" />}
    >
      <Menu.Item icon={!topMenu && <FeatherIcon icon="package" />} key="create-shipment">
        <NavLink onClick={toggleCollapsed} to={`${path}/pages/create-shipment`}>
        สร้างพัสดุ
        </NavLink>
      </Menu.Item>


      <Menu.Item icon={!topMenu && <FeatherIcon icon="plane" />} key="shipment">
        <NavLink onClick={toggleCollapsed} to={`${path}/pages/shipments`}>
        ติดตามพัสดุ
        </NavLink>
      </Menu.Item>

      { userId && ( userId == 11442 || userId == 65127 || userId == 62712 || userId == 17136 || userId == 64471 || userId == 76402 || userId == 65585 || userId == 67166 || userId == 65128 ) ?
      <Menu.Item icon={!topMenu && <FeatherIcon icon="drop" />} key="dropoff">
        <NavLink onClick={toggleCollapsed} to={`${path}/pages/dropoff`}>
        รับพัสดุ Dropoff
        </NavLink>
      </Menu.Item>
      :
      <></>
      }

      <Menu.Item icon={!topMenu && <FeatherIcon icon="payment" />} key="payment">
        <NavLink onClick={toggleCollapsed} to={`${path}/pages/bills`}>
        รายการรอบบิลชำระ
        </NavLink>
      </Menu.Item>

    </Menu>
  );
};

MenuItems.propTypes = {
  darkMode: propTypes.bool,
  topMenu: propTypes.bool,
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
